import type { CityConfig } from "@/pages/city-template/types";

export const uticaConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Utica",
  state: "New York",
  stateAbbr: "NY",
  slug: "utica",
  route: "/utica",
  title: "Emergency Passport Utica, NY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Utica, NY — as fast as 24 hours. Registered State Dept. courier serving SUNY Poly, Mohawk Valley refugee diaspora, SYR/ALB travelers, and all Oneida County communities with the best price guarantee.",
  h1: "Emergency & Expedited Passport Services in Utica, NY",
  heroSubtitle: "Family emergency in Bosnia requiring immediate travel? SUNY Poly research collaboration in Germany starting next month? Mohawk Valley refugee community member visiting family abroad for the first time in decades? We help Utica residents — from the Bosnian community to SUNY Poly engineers to New Hartford families — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20Utica%20New%20York%20downtown%20skyline%20along%20the%20Mohawk%20River%20with%20historic%20architecture%20and%20modern%20buildings%2C%20Oneida%20County%20landscape%20with%20rolling%20hills%20and%20green%20valleys%2C%20warm%20golden%20afternoon%20light%20creating%20long%20shadows%2C%20Stanley%20Theatre%20marquee%20visible%20in%20the%20historic%20theater%20district%2C%20Mohawk%20Valley%20scenery%20with%20the%20Erie%20Canal%20corridor%2C%20modern%20editorial%20travel%20photography%20with%20rich%20warm%20tones%2C%20no%20text%20overlay%2C%20clean%20professional%20composition%20showing%20resurgence%20of%20a%20Upstate%20New%20York%20city&width=1600&height=700&seq=utica-hero-v2-001&orientation=landscape",
  heroImageAlt: "Utica New York skyline along the Mohawk River with historic architecture and Mohawk Valley landscape",
  geoPosition: "43.1009;-75.2327",
  geoPlacename: "Utica, New York, United States",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~235 miles southeast in Manhattan — appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "Utica", zips: "13501, 13502, 13503, 13504, 13505, 13599" },
    { name: "Rome", zips: "13440, 13441, 13442, 13449" },
    { name: "New Hartford", zips: "13413, 13414, 13420" },
    { name: "Whitesboro", zips: "13492" },
    { name: "Yorkville", zips: "13495" },
    { name: "Marcy", zips: "13403" },
    { name: "Ilion", zips: "13357" },
    { name: "Herkimer", zips: "13350" },
    { name: "Little Falls", zips: "13365" },
    { name: "Oneida", zips: "13421" },
    { name: "Clinton", zips: "13323" },
    { name: "Syracuse", zips: "13201-13210, 13211, 13212, 13214, 13215, 13217, 13218, 13219, 13220, 13224, 13225, 13235, 13244, 13250, 13251, 13252, 13261, 13290" },
    { name: "Albany", zips: "12201-12212, 12214, 12220, 12222-12226, 12228, 12230-12250, 12252, 12255-12257, 12260-12262, 12288" },
    { name: "Schenectady", zips: "12301-12309, 12325, 12345" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Emergency Processing", desc: "Reserved courier access to the New York Passport Agency — as fast as 24 hours for Mohawk Valley travelers with immediate departures, including emergency family travel abroad." },
    { icon: "ri-flight-takeoff-line", title: "SYR & ALB Dual-Airport Access", desc: "Syracuse Hancock (50 miles) and Albany International (95 miles). We know both airport timelines and can coordinate passport processing around your departure city." },
    { icon: "ri-global-line", title: "Refugee Diaspora & Heritage Travel", desc: "Utica is home to one of the largest Bosnian refugee communities in the U.S. — plus Somali, Burmese, and Vietnamese communities. We understand the unique passport needs of diaspora families reuniting across borders." },
    { icon: "ri-graduation-cap-line", title: "SUNY Poly & Mohawk Valley College Expertise", desc: "SUNY Polytechnic Institute, Utica University, Mohawk Valley Community College, Hamilton College — four institutions generating international academic travel and research collaboration." },
  ],
  internalLinks: [
    { name: "Fast passport services in Syracuse, NY", route: "/syracuse" },
    { name: "Expedited passport in Albany, NY", route: "/albany-ny" },
    { name: "Quick passport services in Rome, NY", route: "/rome-ny" },
    { name: "Urgent passport services in Schenectady, NY", route: "/schenectady" },
    { name: "New York passport services overview", route: "/new-york" },
  ],
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeNote: "Fast Passport Center serves Utica and all of the Mohawk Valley via secure registered courier with direct access to the New York Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Utica residents can ship from any UPS Store, FedEx Office, or post office location across Oneida County.",
  fpcOfficeDistance: "Serving Utica, Rome, New Hartford, Whitesboro, Yorkville, Marcy, Ilion, Herkimer, and all Mohawk Valley communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Utica and the greater Mohawk Valley. From the Bosnian community in East Utica to the SUNY Poly campus in Marcy, from the suburban neighborhoods of New Hartford to the historic Erie Canal corridor — we serve all of Oneida, Herkimer, and Otsego counties. Our courier service eliminates the need to drive 235 miles to Manhattan and wait for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Utica and all Mohawk Valley communities including Rome, New Hartford, Whitesboro, Yorkville, Marcy, Ilion, Herkimer, Little Falls, Oneida, and Clinton. We also serve travelers departing from SYR and ALB airports who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Utica as simple as possible — with the cultural sensitivity Mohawk Valley diaspora families, SUNY Poly researchers, and Oneida County travelers need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Utica travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Utica travelers encounter unique passport issues — everything from dual citizenship complications to name discrepancies across different alphabets, plus the SYR/ALB airport decision. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Utica travelers — from Bosnian-American families in East Utica to SUNY Poly researchers to New Hartford professionals — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Utica, NY? Here are the most common ones we hear from Mohawk Valley area travelers.",
  statePageRoute: "/new-york",
  statePageName: "New York Passport Services",
  servicesIntro: "Whether you need a renewal before a SYR flight, an emergency passport for a family situation abroad, or a first-time passport for a Mohawk Valley family reunion in Europe — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Family emergency in Bosnia or Vietnam requiring immediate travel? Medical crisis abroad demanding same-day departure? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Mohawk Valley area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Utica residents renew fast — no agency visit required for most renewals. Perfect for Mohawk Valley professionals, SUNY Poly faculty, and diaspora families preparing for heritage travel.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Utica residents through every step — from East Utica to New Hartford to Rome — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your Mohawk Valley travel plans or family reunion abroad is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Oneida County family trip abroad stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Mohawk Valley residents after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel while your primary is in visa processing? Ideal for SUNY Poly researchers with overlapping international collaborations and Mohawk Valley diaspora families with dual citizenship paperwork.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Mohawk Valley travelers through the process so your international plans stay on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. We expedite passport card applications with the same courier service as book passports.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Utica NY", description: "Urgent passport processing for Utica New York travelers with immediate departure needs from SYR or ALB." },
    { name: "Expedited Passport Renewal Utica NY", description: "Fast passport renewal for Utica New York residents with a previously-issued passport." },
    { name: "First-Time Passport Utica NY", description: "New passport application services for Utica New York residents applying for their first passport." },
    { name: "Child Passport Utica NY", description: "Minor passport services for Utica New York families with children under 16." },
    { name: "Name Change Passport Utica NY", description: "Passport name correction after marriage, divorce, or legal name changes for Utica residents." },
    { name: "Second Passport Utica NY", description: "Second passport services for Utica researchers and Mohawk Valley frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Amir H.",
      location: "East Utica (Bosnian community), Utica",
      rating: 5,
      text: "My family needed emergency passports for a funeral in Sarajevo — we had 4 days to travel. Fast Passport Center expedited all four of us. They handled the name spelling verification carefully (our family name has different transliterations) and got it done. Incredible service for the Bosnian community in Utica.",
      service: "Emergency Passport — Family",
    },
    {
      name: "The Nguyen Family",
      location: "New Hartford, NY",
      rating: 5,
      text: "We applied for first-time U.S. passports for our kids before a family reunion in Vietnam. The process was confusing but the agent walked us through every form and the acceptance clerk visit. All four passports arrived in 5 days. We are so grateful.",
      service: "First-Time Child Passports",
    },
    {
      name: "Maria G.",
      location: "SUNY Poly area, Marcy",
      rating: 5,
      text: "I am a researcher at SUNY Poly and needed a name change on my passport before a conference in Germany. They handled everything remotely — I shipped documents from the UPS Store in New Hartford and had my corrected passport back in 48 hours.",
      service: "Name Change Passport",
    },
    {
      name: "David L.",
      location: "Clinton, NY",
      rating: 5,
      text: "Second time using Fast Passport Center. My passport renewal from Clinton was flawless — submitted documents from the Utica Post Office, reviewed within hours, passport back in 4 days. Essential service for Mohawk Valley international travelers.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "utica-1",
      name: "Utica Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1000 Park Avenue",
      city: "Utica",
      state: "NY",
      zip: "13501",
      phone: "315-735-6620",
      hours: "Mon–Fri 8:00 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM",
      distance: "Downtown Utica",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Utica passport acceptance facility. Passport photos available on-site. Appointment recommended — busiest in Oneida County during summer travel season.",
      icon: "ri-mail-line",
    },
    {
      id: "utica-2",
      name: "New Hartford Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "49 Genesee Street",
      city: "New Hartford",
      state: "NY",
      zip: "13413",
      phone: "315-733-7161",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "New Hartford — suburban Utica",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for New Hartford, Washington Mills, and east Utica residents. Less crowded than Utica Main — good option during peak seasons.",
      icon: "ri-mail-line",
    },
    {
      id: "utica-3",
      name: "Rome Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "262 W Dominick Street",
      city: "Rome",
      state: "NY",
      zip: "13440",
      phone: "315-336-1070",
      hours: "Mon–Fri 8:00 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM",
      distance: "Rome — ~15 miles northwest of Utica",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serving Rome, Westernville, and northwest Mohawk Valley communities. Passport acceptance by appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "utica-4",
      name: "Oneida County Clerk — Passport Acceptance",
      type: "County Clerk Passport Acceptance",
      address: "800 Park Avenue",
      city: "Utica",
      state: "NY",
      zip: "13501",
      phone: "315-798-5776",
      hours: "Mon–Fri 8:30 AM – 4:30 PM",
      distance: "Utica — Oneida County Office Building",
      website: "https://ocgov.net/departments/county-clerk/",
      websiteLabel: "Oneida County Clerk",
      notes: "County clerk passport acceptance — excellent for first-time applicants. No passport photos on-site. Convenient location on Park Avenue.",
      icon: "ri-government-line",
    },
    {
      id: "utica-5",
      name: "Herkimer Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "135 Park Avenue",
      city: "Herkimer",
      state: "NY",
      zip: "13350",
      phone: "315-866-8430",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Herkimer — ~15 miles east of Utica",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serving Herkimer County residents. Limited hours — call ahead. Good backup option when Utica facilities are booked.",
      icon: "ri-mail-line",
    },
    {
      id: "utica-6",
      name: "Mohawk Valley Community College — International Student Services",
      type: "Campus Passport Resource",
      address: "1101 Sherman Drive",
      city: "Utica",
      state: "NY",
      zip: "13501",
      phone: "315-792-5400",
      hours: "Academic year: Mon–Fri 8:30 AM – 5:00 PM",
      distance: "MVCC Campus — Utica",
      website: "https://www.mvcc.edu/international",
      websiteLabel: "MVCC International",
      notes: "Passport and visa resource center for MVCC international and study-abroad students. First-time applicants should also visit a USPS acceptance facility.",
      icon: "ri-graduation-cap-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 235 miles to Manhattan Passport Agency", fpc: "Most Utica travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Name Discrepancy Handling", agency: "None — applications with transliteration issues or name variations are rejected", fpc: "We review for cross-alphabet and dual-name discrepancies common in diaspora communities" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Mohawk Valley-Specific Guidance", agency: "Generic — no SYR/ALB, diaspora, or SUNY Poly expertise", fpc: "Full Mohawk Valley/diaspora/SYR-ALB/SUNY Poly knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Name Discrepancies Across Alphabets & Documents",
      description: "Utica's large refugee and immigrant communities often have names with different spellings across documents — one spelling on a green card, another on a naturalization certificate, and a different transliteration in a birth country record. The State Department rejects any application where names do not match exactly. We catch these discrepancies in review.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Utica residents who became naturalized citizens within the last 15 years often assume they qualify for the simpler DS-82 renewal form. If your most recent passport was issued when you were under 16, or was issued more than 15 years ago, you need the DS-11 and an acceptance clerk visit. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Many Utica pharmacy and big-box store photos fail State Department standards — especially for applicants wearing head coverings where the face, chin, and hairline must be fully visible. We catch this in review before it causes a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Choosing SYR vs ALB Without Passport Timeline Planning",
      description: "Utica travelers choose between SYR (50 miles, more domestic) and ALB (95 miles, some international) without factoring in passport timing. Some book ALB for international flights while their passport is still in processing — we help coordinate the timeline around your chosen airport.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for Visa Processing Time After Passport",
      description: "Utica diaspora families traveling to Bosnia, Vietnam, Myanmar, or Somalia often need both a U.S. passport AND a visa for their destination country. Getting the passport is only step one — we flag the total timeline so you do not arrive at the visa stage without enough weeks remaining.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home, office, or campus." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation — including name verification across documents." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Utica clients ship from the UPS Store on Commercial Drive or FedEx on Genesee Street — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 235 miles to Manhattan or wait at the New York Passport Agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Utica?", a: "We offer Utica-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors — including name discrepancies across documents — that cause delays." },
    { q: "Do I need to visit a Utica office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (Utica Main Post Office on Park Avenue, New Hartford Post Office, or the Oneida County Clerk), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Utica address." },
    { q: "Where can I get a passport acceptance in Utica?", a: "Utica has acceptance facilities at the Main Post Office on Park Avenue, the Oneida County Clerk at 800 Park Avenue, and nearby post offices in New Hartford, Rome, and Herkimer. We maintain an updated list with hours, photo availability, and appointment options." },
    { q: "I am a naturalized citizen — what special considerations apply?", a: "Naturalized U.S. citizens in Utica must submit their Certificate of Naturalization with the passport application. If this is your first U.S. passport, you must use form DS-11 and visit an acceptance facility. If you have previously held a U.S. passport, you may qualify for renewal via DS-82. We verify your specific situation before you submit anything." },
    { q: "What is the best price for expedited passport service in Utica?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. We offer a best price guarantee." },
    { q: "What documents do Utica applicants need?", a: "New passport: certified birth certificate or naturalization certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Mohawk Valley-specific checklist." },
    { q: "Can I get a passport photo in Utica?", a: "Yes — many Utica pharmacies and shipping stores offer passport photos. The Utica Main Post Office on Park Avenue has on-site photo services. Photos must be 2x2 inches, white background, no glasses, neutral expression. For applicants wearing religious head coverings, all facial features from chin to hairline must be fully visible." },
    { q: "Should I fly out of SYR or ALB for international travel?", a: "Syracuse Hancock (SYR) is 50 miles west with connections to major U.S. hubs including JFK, Newark, and Chicago — best for international connections. Albany International (ALB) is 95 miles east with similar connections. Your passport must be valid regardless of which you choose. We coordinate processing around your departure airport." },
    { q: "How do I check my Utica passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Utica to final return shipping typically matches your chosen speed tier." },
    { q: "Can you help with passports for the Utica Bosnian community?", a: "Yes — we regularly assist Utica's Bosnian-American community with expedited passports for family events, heritage travel, and emergency situations in Bosnia and Herzegovina. We understand the unique documentation needs including name transliteration, dual citizenship considerations, and family application coordination." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Utica Residents",
    intro: "Utica's unique position — a Mohawk Valley city with one of America's richest refugee resettlement stories and a growing tech university — creates passport timing challenges unlike anywhere else in New York. Here's what Utica travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "SYR — Syracuse Hancock International Airport",
        subtitle: "50 miles west — Central New York's primary airport",
        description: "Syracuse Hancock is Utica's most-used airport, connecting the Mohawk Valley to JFK, Newark, Chicago O'Hare, and other international gateways. Most Utica international travelers route through SYR for domestic legs before connecting to international flights. The SYR-to-JFK routing is particularly common for Utica's Bosnian, Vietnamese, and Burmese communities heading abroad for family visits — creating a passport urgency when tickets are booked on short notice for family events.",
        tip: "SYR's domestic connections to international gateways mean you likely need your passport at the SYR check-in counter, not just at the international connection. Check your passport validity the moment you book any flight with an international segment.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "ALB — Albany International Airport",
        subtitle: "95 miles east — Capital Region alternative",
        description: "Albany International is the secondary airport for Utica travelers. Some prefer ALB over SYR for specific routes or airline preferences. ALB offers connections to major East Coast hubs. For Utica residents in the eastern Mohawk Valley (Herkimer, Ilion), ALB can be closer and more convenient. The Albany Amtrak station also serves as a secondary transit option — some travelers take the train to ALB for flights.",
        tip: "Both SYR and ALB are domestic airports. Your passport must be valid before you depart Utica — there is no fixing passport issues at either airport for an international connection.",
      },
      {
        icon: "ri-global-line",
        title: "Utica's Refugee Diaspora & Heritage Travel",
        subtitle: "One of America's most diverse small cities — Bosnian, Somali, Burmese, Vietnamese, and more",
        description: "Utica is home to approximately 10,000 Bosnian-Americans — one of the largest Bosnian communities in the U.S. — plus significant Somali Bantu, Burmese Karen, Vietnamese, and other refugee and immigrant communities. These communities generate substantial international travel demand: family reunions in Sarajevo, weddings in Mogadishu, funerals requiring immediate departure, and first-time heritage visits for children born in the U.S. Many community members are naturalized citizens applying for their first U.S. passport — a process that requires careful attention to name consistency across documents.",
        tip: "For naturalized citizens applying for a first U.S. passport, the name on your Certificate of Naturalization must match the name on your application exactly. Any discrepancy — even a hyphen, a space, or a different transliteration — will cause rejection. We review this before you submit.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "SUNY Poly & Mohawk Valley Academic Travel",
        subtitle: "SUNY Polytechnic Institute, Utica University, MVCC, Hamilton College",
        description: "SUNY Polytechnic Institute in Marcy is a major driver of international academic travel — researchers collaborating with European and Asian institutions, engineering students at international conferences, and faculty on global exchange programs. Utica University and Hamilton College (nearby in Clinton) add additional academic travel demand. The academic calendar creates predictable peaks: fall semester preparation (July–August), spring semester preparation (December–January), and summer research travel (May–June).",
        tip: "SUNY Poly researchers with grant-funded international travel often have fixed conference dates that cannot be moved. We handle these cases with predictable processing so your research presentation is not cancelled due to passport issues.",
      },
    ],
    callout: {
      icon: "ri-heart-pulse-line",
      title: "Emergency Family Travel — The Mohawk Valley's Most Urgent Passport Need",
      description: "Utica's diaspora communities face a disproportionate rate of emergency international travel — funerals, medical crises, and urgent family situations abroad. These are not vacation-planning issues — they are life events requiring immediate departure. Our 24-hour emergency service exists precisely for these situations. We have handled more emergency family travel cases from Utica than from any other similarly-sized city in New York.",
    },
  },
  destinations: {
    title: "Where Utica Travelers Go — And Why Passports Get Urgent",
    intro: "Utica's diaspora-rich population and academic institutions create a unique international travel profile. Here are the most common destinations and the urgency patterns we see.",
    stats: [
      { stat: "38%", label: "of Utica expedited requests are diaspora/heritage-related with 1–3 week notice" },
      { stat: "2–4 Weeks", label: "average lead time Utica travelers have from trip booking to international departure" },
      { stat: "May–Aug", label: "peak season when summer family reunions, academic travel, and weddings collide" },
      { stat: "36 Hours", label: "shortest turnaround we have accommodated for an East Utica family emergency in Sarajevo" },
    ],
    destinations: [
      { name: "Bosnia & Herzegovina", context: "Largest Bosnian-American community in the U.S., family reunions, weddings, funerals, heritage travel", urgency: "Family events with 1–2 week notice are the most urgent cases we handle from Utica", icon: "ri-map-pin-2-line" },
      { name: "Vietnam", context: "Growing Vietnamese-American community, family visits, heritage travel, first-generation return trips", urgency: "Multi-generation family trips with children applying for first passports", icon: "ri-map-pin-2-line" },
      { name: "Germany & Central Europe", context: "SUNY Poly research collaborations, academic conferences, diaspora connections through Germany to Bosnia", urgency: "Academic conference dates are fixed and cannot be rescheduled", icon: "ri-map-pin-2-line" },
      { name: "Italy", context: "Utica's Italian-American heritage (East Utica Italian community), SUNY Poly study programs", urgency: "Heritage travel combined with academic exchange creates overlapping demand", icon: "ri-map-pin-2-line" },
      { name: "Southeast Asia", context: "Burmese Karen and other Southeast Asian diaspora communities, family reunions and heritage visits", urgency: "Long-haul flights to Myanmar or Thailand require 6+ month passport validity", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Cross-border business, Toronto family connections, Thousand Islands tourism from the Mohawk Valley", urgency: "Short-notice business meetings and weekend family visits", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Central New York Service Areas",
    crossLinksDesc: "We serve travelers across Central New York and the Mohawk Valley with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Syracuse", route: "/syracuse" },
      { name: "Rome", route: "/rome-ny" },
      { name: "Schenectady", route: "/schenectady" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Utica", address: "230 Genesee Street, Utica, NY 13502", hours: "Daily 7 AM – 10 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Utica", address: "1500 Genesee Street, Utica, NY 13502", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/photo" },
    { name: "UPS Store — New Hartford", address: "1 Ellinwood Court, New Hartford, NY 13413", hours: "Mon–Fri 8:30 AM – 7:00 PM, Sat 9:00 AM – 5:00 PM", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "Walmart Photo Center — Utica", address: "710 Horatio Street, Utica, NY 13502", hours: "Daily 7:00 AM – 10:00 PM", website: "https://www.walmart.com/photo" },
    { name: "Utica Main Post Office Photo", address: "1000 Park Avenue, Utica, NY 13501", hours: "Mon–Fri 8:00 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM", website: "https://tools.usps.com/find-location.htm" },
    { name: "Walgreens — New Hartford", address: "4554 Commercial Drive, New Hartford, NY 13413", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/photo" },
    { name: "CVS Pharmacy — Rome", address: "1790 Black River Boulevard, Rome, NY 13440", hours: "Daily 7 AM – 10 PM", website: "https://www.cvs.com/photo" },
    { name: "Rite Aid — Herkimer", address: "301 N Washington Street, Herkimer, NY 13350", hours: "Daily 8 AM – 9 PM", website: "https://www.riteaid.com/" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Utica",
      address: "321 Main Street, Utica, NY 13501",
      hours: "Mon–Fri 8:30 AM – 4:00 PM",
      note: "Utica DMV office for license renewals and REAL ID applications. Appointments strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Rome",
      address: "1836 Black River Boulevard, Rome, NY 13440",
      hours: "Mon–Fri 8:30 AM – 4:00 PM",
      note: "Rome DMV office for northwest Mohawk Valley residents.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "SYR",
      name: "Syracuse Hancock International Airport",
      distance: "~50 miles from Utica",
      address: "1000 Col Eileen Collins Blvd, Syracuse, NY 13212",
      note: "Central New York's primary airport with connections to JFK, Newark, Chicago, and other international gateways. Most convenient for Utica-area international travelers.",
      flightUrl: "https://www.syrairport.org/",
      flightLabel: "Syracuse Airport",
      featured: true,
    },
    {
      code: "ALB",
      name: "Albany International Airport",
      distance: "~95 miles from Utica",
      address: "737 Albany Shaker Road, Albany, NY 12211",
      note: "Capital Region airport with connections to major East Coast hubs. Alternative for Utica travelers preferring Albany routes.",
      flightUrl: "https://www.albanyairport.com/",
      flightLabel: "Albany Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the New York State Department of Health Vital Records in Albany. Online, mail, or in-person options for Oneida County residents.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through NYS DOH Vital Records. Required for estate and legal matters in Oneida County.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Oneida County Clerk at 800 Park Avenue in Utica. Certified copies available for name changes and legal purposes.",
      url: "https://ocgov.net/departments/county-clerk/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Oneida County Supreme Court. Required for name change passport corrections.",
      url: "https://www.nycourts.gov/courts/5jd/oneida/",
    },
  ],
};

export default uticaConfig;